import React, { createContext, useContext, useMemo, useState } from 'react';
import { Originator } from 'types';
import { GridParams } from './register-types';
import { useParams } from 'react-router-dom';

export type OriginatorContextType = {
  originator: Originator | undefined;
  setOriginator?: React.Dispatch<React.SetStateAction<Originator | undefined>>;
  nameFilter?: string;
  setNameFilter?: React.Dispatch<React.SetStateAction<string | undefined>>;
  aggregations?: { key: string; value: number }[];
  setAggregations?: React.Dispatch<
    React.SetStateAction<{ key: string; value: number }[]>
  >;
};

const OriginatorContext = createContext<OriginatorContextType>({
  setOriginator: () => {},
  originator: undefined,
});

export const OriginatorContextProvider: React.FC<{
  originator?: Originator;
}> = ({ originator, children }) => {
  const { search } = useParams<GridParams>();
  const morg = useMemo(() => originator, [originator]);
  const [nameFilter, setNameFilter] = useState<string | undefined>(search);
  const [aggregations, setAggregations] = useState<
    { key: string; value: number }[]
  >([]);

  return (
    <OriginatorContext.Provider
      value={{
        originator: morg,
        setNameFilter,
        nameFilter,
        aggregations,
        setAggregations,
      }}
    >
      {children}
    </OriginatorContext.Provider>
  );
};
export const useOriginatorContext = () => useContext(OriginatorContext);
